import React, { useEffect, useRef } from 'react';
import { FaExclamationTriangle } from 'react-icons/fa';
import PropTypes from 'prop-types';

const OverdueAppointments = ({ notifications, onClose }) => {
  const modalRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        onClose(); // Chama a função de fechamento ao clicar fora
      }
    };

    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [onClose]);

  return (
    <div
      ref={modalRef}
      className="absolute right-0 mt-2 w-80 bg-white rounded-lg shadow-lg z-50"
      role="dialog"
      aria-modal="true"
    >
      <div className="bg-red-600 text-white px-4 py-2 rounded-t-lg flex items-center">
        <FaExclamationTriangle className="mr-2" />
        <h4 className="text-lg font-semibold text-white">
          Compromissos Atrasados
        </h4>
      </div>
      <ul className="p-4 space-y-2 max-h-60 overflow-y-auto">
        {notifications.length > 0 ? (
          notifications.map((notification, index) => (
            <li
              key={index}
              className="flex justify-between items-center bg-red-50 p-3 rounded-lg shadow-sm hover:bg-red-100 transition duration-200 ease-in-out"
            >
              <div>
                <p className="text-gray-800 font-medium">
                  {notification.descricao}
                </p>
                <p className="text-sm text-gray-600">
                  {new Date(notification.dataHora).toLocaleString()}
                </p>
              </div>
              <FaExclamationTriangle className="text-red-500 text-xl" />
            </li>
          ))
        ) : (
          <li className="text-center text-gray-600 py-4">
            Nenhuma notificação atrasada
          </li>
        )}
      </ul>
    </div>
  );
};

// Prop types validation
OverdueAppointments.propTypes = {
  notifications: PropTypes.array.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default OverdueAppointments;
